module.exports = __webpack_public_path__ + "img/shieldIcon.e9307f41.svg";